import { Button } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { useMsal } from "@azure/msal-react";
import styles from "./DuplicateEmailNotice.module.scss";

export const DuplicateEmailNotice = () => {
  const { instance } = useMsal();

  const handleSignIn = async () => {
    try {
      await instance.logoutRedirect({ postLogoutRedirectUri: "/login" });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className={styles.notice}>
      <h2>Tento email už je v Bridge zaregistrovaný</h2>
      <p>
        Účet s tímto emailem už existuje. Přihlaste se prosím svým původním
        účtem; pokud si nepamatujete, jakou metodou jste se registrovali,
        zkuste všechny dostupné možnosti přihlášení.
      </p>
      <Button
        variant="contained"
        size="medium"
        startIcon={<LoginIcon />}
        onClick={handleSignIn}
      >
        Přihlásit se
      </Button>
    </div>
  );
};
